var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-90.58425 -75.037 785.0635 450.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.895 159l59-159h-39l-27 69 6-69h-41l-59 159h38l29-77-5 75zm46 0l59-159h-37l-60 159zm107-10l-2-80 56-65zm272-56l-190 49 5-15h-40l13-38h34l10-29-34 2 12-32h33l11-29h-107l-39 46 19-47h-38l-59 159h39l25-68v68h50l-179 47c-18.667 5.333-35.334 7.667-50 7-14.667-.667-26-4.667-34-12-18-13.333-24.334-33.667-19-61 3.333-18 10.666-35.333 22-52-26.667 28-46.334 51.667-59 71-14 20.667-23 41-27 61s-1.667 36.333 7 49c23.333 38.667 74.333 41.333 153 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNike);
export default __webpack_public_path__ + "static/media/Nike.6dee3d570c60b81c2b9adaa9dcb7af69.svg";
export { ForwardRef as ReactComponent };